import React from 'react';
import PropTypes from 'prop-types';
import {Table, Button} from 'semantic-ui-react';
import moment from 'moment';
const SystemInfoMessages = ({items, onAdd, onEdit, onDelete, onAddUser}) => {
    return (
        <Table celled>
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                    <Table.HeaderCell>System Information Message</Table.HeaderCell>
                    <Table.HeaderCell>Effective Date</Table.HeaderCell>
                    <Table.HeaderCell>Expiration Date</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {items && items.length ?
                items.map((item, key) =>
                    <Table.Row key={key}>
                        <Table.Cell>
                            <Button icon="edit" data={item} onClick={onEdit} />
                            <Button negative icon="trash" data={item} onClick={onDelete} />
                        </Table.Cell>
                        <Table.Cell>{item.message}</Table.Cell>
                        <Table.Cell>{moment(item.start).format('LL')}</Table.Cell>
                        <Table.Cell>{moment(item.end).format('LL')}</Table.Cell>
                    </Table.Row>) : null}
            </Table.Body>
            <Table.Footer fullWidth>
                <Table.Row>
                    <Table.HeaderCell colSpan="4"><Button onClick={onAddUser}>Add Admin User</Button><Button primary floated="right" onClick={onAdd}>Add</Button></Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
        
    );
};

SystemInfoMessages.propTypes = {
    items: PropTypes.array,
    onAdd: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onAddUser: PropTypes.func,
};

export default SystemInfoMessages;